import { render } from "./BaseIconText.vue?vue&type=template&id=464c7dcf&ts=true"
import script from "./BaseIconText.vue?vue&type=script&lang=ts"
export * from "./BaseIconText.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__